define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Ref",
	"csi/prefs",
	"csi/reflection",
	"Export"
], function(declare,def,Ref,prefs,reflection,Export) {

	return declare(Ref, {
		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: customize heading relationship by export class
			// FIX: Should we filter custom views by Export Batch User?
			var	cls = reflection.getClass(ctx.defView.getFieldValue("ClassName"));
			h.m_relationship = cls ? prefs.getStoreRelationship(def.composeViewKey(Export.VIEW, cls.getType())) : null;
			return this.inherited(arguments);
		}
	});
});
